import Skeleton from "react-loading-skeleton";

function PolicySkeleton() {
    return (
        <>
            <Skeleton width="70%" height={40} style={{ marginBottom: 24 }} />
            <Skeleton count={3} height={18} style={{ marginBottom: 10 }} />

            {[...Array(4)].map((_, i) => (
                <div key={i} style={{ marginTop: 28 }}>
                    <Skeleton width="50%" height={22} />
                    <Skeleton count={4} height={16} style={{ marginTop: 10 }} />
                </div>
            ))}
        </>
    );
}

export default PolicySkeleton;
